import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import { forwardRef } from "react";
import { LoadingButton } from "@mui/lab";
import { Button } from "../Button/index.js";
import { ModalBase } from "./ModalBase.js";
const Modal_Modal = /*#__PURE__*/ forwardRef(function({ children, primaryButtonDanger = false, primaryButtonDisabled = false, primaryButtonLoading = false, onClose, onPrimaryButtonClick, primaryButtonText, secondaryButtonText, ...rest }, ref) {
    return /*#__PURE__*/ jsx(ModalBase, {
        onClose: onClose,
        ref: ref,
        Footer: /*#__PURE__*/ jsx(Box, {
            p: 1,
            justifyContent: "flex-end",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            children: /*#__PURE__*/ jsxs(Stack, {
                direction: "row",
                spacing: 1,
                children: [
                    onPrimaryButtonClick && /*#__PURE__*/ jsx(LoadingButton, {
                        variant: "contained",
                        color: primaryButtonDanger ? 'error' : 'primary',
                        loading: primaryButtonLoading,
                        onClick: onPrimaryButtonClick,
                        disabled: primaryButtonDisabled,
                        children: /*#__PURE__*/ jsx("span", {
                            children: primaryButtonText || 'Ok'
                        })
                    }),
                    /*#__PURE__*/ jsx(Button, {
                        variant: "secondary",
                        onClick: onClose,
                        children: secondaryButtonText || 'Cancel'
                    })
                ]
            })
        }),
        ...rest,
        children: children && /*#__PURE__*/ jsx(Box, {
            px: 2,
            sx: {
                paddingBottom: void 0 === onPrimaryButtonClick ? 1 : 0
            },
            children: children
        })
    });
});
export { Modal_Modal as Modal };

//# sourceMappingURL=Modal.js.map